import { useQuery } from "react-query";
import { t } from "@/i18n-js/instance";
import { marketingEmailTemplatesApi } from "@/react/api/marketingEmailTemplateApi";
import { useToast } from "@circle-react-uikit/ToastV2";

export const useTemplatesExists = () => {
  const toast = useToast();

  const { data, isLoading, isError } = useQuery<{ exists: boolean }>({
    queryKey: ["marketingEmailTemplates", "exists"],
    queryFn: () => marketingEmailTemplatesApi.exists(),
    onError: (error: unknown) => {
      toast.error(t("request_failure_message"));
      console.error(error);
    },
  });

  const doesTemplatesExist = data?.exists;

  return { doesTemplatesExist, isLoading, isError };
};
